import { createErrorMatcher } from '@shared/lib/http-error';

const isUserNotConfirmedError = createErrorMatcher('UserNotConfirmedException');
const isNotAuthorizedError = createErrorMatcher('NotAuthorizedException');

export { isUserNotConfirmedError, isNotAuthorizedError };
